import { useState } from "react";
import Slider from "react-slick";
import { useTranslation } from "../i18n";

import "./Ablauf.css";

const days = [
  {
    images: [
      "https://globusliebe.com/wp-content/uploads/2020/06/grabkapelle-stuttgart.jpg",
      "https://www.1819bistro.de/wp-content/uploads/2022/01/Sektempfang_Gluecksmomente.jpeg",
      "https://media01.stockfood.com/largepreviews/MjIwODEyNDExMA==/71229810-Grabkapelle-auf-dem-Wuerttemberg-Rotenberg-Stuttgart-Baden-Wuerttemberg-Deutschland.jpg",
      "https://www.restaurant-waldschloessle.de/templates/yootheme/cache/4e/aussenaufnahme_0793_1200x800px-4eb1a9ef.webp",
    ],
    eventKeys: ["treffenPriesterhaus", "standesamtlicheTrauung", "essenWaldschloessle"],
  },
  {
    images: [
      "https://images.eventbackline.com/_/w:1280/plain/production://public/uploads/Bu6bRZMQodoV0zur9tI7jYeK6yDU7yx43s4feyw8.jpg",
      "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=400&q=80",
      "https://images.unsplash.com/photo-1509228468518-180dd4864904?auto=format&fit=crop&w=400&q=80",
    ],
    eventKeys: ["hochzeitsfeier"],
  },
];

function Ablauf({ isOneDay = false }) {
  const { t } = useTranslation();
  const [activeDay, setActiveDay] = useState(0);

  // Filter days based on isOneDay prop
  const filteredDays = isOneDay ? [days[1]] : days; // Show only day 2 (index 1) for one-day, both days for two-day

  const sliderSettings = {
    dots: !isOneDay, // Only show dots for two-day view
    infinite: !isOneDay, // Only allow infinite scrolling for two-day view
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: !isOneDay, // Only autoplay for two-day view
    autoplaySpeed: 10000,
    beforeChange: (oldIndex, newIndex) => {
      setActiveDay(newIndex);
    },
    customPaging: (i) => (
      <button
        className={
          activeDay === i
            ? "ablauf-drawer-circle active"
            : "ablauf-drawer-circle"
        }
      >
        {i === 0 ? t("ablauf.dates.day1") : t("ablauf.dates.day2")}
      </button>
    ),
    appendDots: (dots) => <div className="ablauf-drawer-nav">{dots}</div>,
  };

  return (
    <section className="ablauf-layout">
      <div className="ablauf-tag-headline">
        <span>
          {isOneDay 
            ? t("ablauf.dates.day2") 
            : (activeDay === 0 ? t("ablauf.dates.day1") : t("ablauf.dates.day2"))
          }
        </span>
      </div>
      <Slider {...sliderSettings}>
        {filteredDays.map((day, idx) => (
          <div key={idx}>
            <div className="ablauf-inner">
              <div className="ablauf-images">
                <img
                  src={day.images[0]}
                  alt={t("ablauf.alt")}
                  className="ablauf-portrait active"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="ablauf-explainer">
                {day.eventKeys.map((eventKey, i) => (
                  <div key={i} className="ablauf-block active">
                    <h3 className="ablauf-title">
                      {t(`ablauf.events.${eventKey}`)}
                    </h3>
                    <p 
                      className="ablauf-desc"
                      dangerouslySetInnerHTML={{ __html: t(`ablauf.descriptions.${eventKey}`) }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default Ablauf;
